<template>
  <Page>
    <h1>{{ $t("main.title") }}</h1>
    <RCard>
      <table class="container-full table-hover">
        <thead>
          <tr>
            <th>Действие</th>
            <th>Дата и время создания</th>
            <th>Серийный номер сосуда</th>
            <th>Цифровой паспорт в Ethereum Blockchain</th>
          </tr>
        </thead>
        <tbody v-if="list">
          <tr v-for="(liability, i) in list.edges" :key="i">
            <td>
              <router-link
                :to="{
                  name: 'details',
                  params: { address: liability.node.address },
                }"
              >{{ $t("main.view") }}</router-link>
            </td>
            <td>{{ new Date(liability.node.timestamp).toLocaleString() }}</td>
            <td>{{ getFactoryNumber(liability.node.objectiveData) }}</td>
            <td>
              <RChainExplorer :address="liability.node.address" />
            </td>
          </tr>
        </tbody>
      </table>
      <RLoader v-if="loader" />
      <div v-else>
        <button
          v-if="canPrevPage"
          @click="showMore(true)"
          :disabled="loader"
          style="margin-right: 10px;"
        >
          <template v-if="loader">...</template>
          <template v-else>{{ $t("main.prev") }}</template>
        </button>
        <button v-if="canNextPage" @click="showMore(false)" :disabled="loader">
          <template v-if="loader">...</template>
          <template v-else>{{ $t("main.next") }}</template>
        </button>
      </div>
    </RCard>
  </Page>
</template>

<script>
import gql from "graphql-tag";
import Page from "../components/layout/Page";
import { parse } from "../utils/tools";

export default {
  components: { Page },
  data() {
    return {
      model: "QmWHWLZ2dQr7rzvNvzBWKaAf6eJD7m9mzdvvg9QizBpVqZ",
      // model: "QmRZ4hNBbpzq7oZBkRtHcEcpSoff4hDF3kLKR3nEyxeED3",
      itemsPerPage: 10,
      hasNextPage: null,
      hasPrevPage: null
    };
  },
  apollo: {
    list: {
      query: gql`
        query getList(
          $model: String!
          $first: Int
          $last: Int
          $after: String
          $before: String
          $sort: LiabilitySchemaSortEnum!
        ) {
          list: liabilities(
            filters: { model: $model }
            first: $first
            after: $after
            last: $last
            before: $before
            sort: [$sort]
          ) {
            edges {
              node {
                id
                address
                model
                objective
                objectiveData
                result
                promisee
                promisor
                token
                cost
                timestamp
              }
              cursor
            }
            pageInfo {
              startCursor
              hasNextPage
              hasPreviousPage
              endCursor
            }
          }
        }
      `,
      variables() {
        return {
          model: this.model,
          first: this.itemsPerPage,
          after: null,
          sort: "TIMESTAMP_DESC"
        };
      }
    }
  },
  computed: {
    canNextPage() {
      if (this.hasNextPage !== null) {
        return this.hasNextPage;
      } else if (this.list) {
        return this.list.pageInfo.hasNextPage;
      } else {
        return false;
      }
    },
    canPrevPage() {
      if (this.hasPrevPage !== null) {
        return this.hasPrevPage;
      } else if (this.list) {
        return this.list.pageInfo.hasPreviousPage;
      } else {
        return false;
      }
    },
    loader() {
      return this.$apollo.queries.list.loading;
    }
  },
  methods: {
    async showMore(previous = false) {
      await this.$apollo.queries.list.setVariables(
        previous
          ? {
              model: this.model,
              last: this.itemsPerPage,
              before: this.list.pageInfo.startCursor,
              sort: "TIMESTAMP_DESC"
            }
          : {
              model: this.model,
              first: this.itemsPerPage,
              after: this.list.pageInfo.endCursor,
              sort: "TIMESTAMP_DESC"
            }
      );
      if (previous) {
        this.hasPrevPage = null;
        this.hasNextPage = true;
      } else {
        this.hasPrevPage = true;
        this.hasNextPage = null;
      }
    },
    getFactoryNumber(data) {
      // return parse(data, "cylinder_serial_number");
      return parse(data, "factory_number");
    }
  }
};
</script>
